<template>
  <v-container class="app-page-container">
      <v-card class="shadow-none app-page-card">
            <v-layout wrap>
              <div v-if="getShowModalMessageResult">{{processModalResult()}}</div>
              <div v-if="need_init && getLanguageIcons && user">{{initData()}}</div>
              
              <v-flex xs12 v-if="prepared">
                <v-card class="shadow-none">
                  <v-card-text>
                    <v-layout>
                      <v-flex xs11>
                        <h2>{{content.brc.chapter.name}}</h2>
                      </v-flex>
                      <v-flex xs1>
                        <small>primary language:</small> <br/>
                        <v-menu class="lang-wrapper" offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" class="lang-change-widget background-transparent shadow-none">
                              <img class="lang-icon" :src="getLanguageIcons[lang_index].url"/> {{ getLanguageIcons[lang_index].title }}
                            </v-btn>
                          </template>
                            <v-list dense>
                              <v-list-item-group>
                                <v-list-item v-for="(language, index) in getLanguageIcons" :key="index" @click="langClick(index)">
                                  <img class="lang-icon" :src="language.url"/>
                                  <v-list-item-title v-text="language.title"></v-list-item-title>
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-text v-if="access_denied">
                      <v-layout align-center>
                        <h1>You don't have a permission to edit this content.</h1>
                      </v-layout>
                  </v-card-text>

                      <v-card v-if="!access_denied" class="shadow-none">
                        <div v-for="(element, index) in content.element_list" :key="element.id" class="universal-row-item">                                
                          <v-layout class="px-5">                
                            <v-flex xs11> 
                                <LessonElement v-bind:my_element='element' v-bind:permissions = 'content.permissions.list' v-bind:lang_index='""+lang_index'/>
                            </v-flex>
                            <v-flex xs1 class="vertically-horizontally-centered">
                              <v-layout v-if="getObjectPermissions()"> 

                                <div class="arrow-ordering-items mx-2">
                                  <v-icon @click="index > 0 ? changeOrder(index-1) : ''" :class="['material-icons-round', (index == 0) ? 'arrow-ordering-items__icon--disabled cursor-not-allowed':'']">arrow_upward</v-icon>
                                  <v-icon @click="index < content.element_list.length-1 ? changeOrder(index) : ''" :class="['material-icons-round', (index == content.element_list.length-1) ? 'arrow-ordering-items__icon--disabled cursor-not-allowed':'']">arrow_downward</v-icon>
                                </div>

                                <v-icon @click="tryDeleteElement(index)" class="mx-2">mdi-delete</v-icon>
                              </v-layout>
                            </v-flex>
                          </v-layout>                             
                        </div> 
                        <v-card color = "#DDDDFF" v-if="getObjectPermissions()">
                          <v-card-text>
                            <v-layout row justify-center>                
                              <v-icon v-if = "content.permissions.list[0].role_code >= systemPermissions.course_content_creator" @click="addNewElement()">mdi-plus-circle-outline</v-icon>
                            </v-layout>        
                          </v-card-text>
                        </v-card> 
                      </v-card>                  
                </v-card> 
              </v-flex>
          </v-layout>
      </v-card>
  </v-container>
</template>

<script>
import axios from '../../../axios-auth.js'
import LessonElement from './lesson_element.vue'
import {mapGetters} from 'vuex'

  export default {
    data() {
      return {
        content: [],
        access_denied: false,
        lang_index: 0,
        need_init : false,
        prepared : false,
        systemPermissions: null,
        deleteIndex : -1
      }
    },
    computed: 
        mapGetters([
                        'getShowModalMessageResult',                        
                        'getLanguageIcons',
                        'user'                       
                    ])
    ,
    mounted () {
      this.need_init = true
      this.prepared = false
   },
   components :{
     LessonElement
   },
   methods: {
    initData() {        
        this.need_init = false
        this.lang_index = localStorage.getItem('CourseLangIndex') == null ? this.user.lang_id-1 : localStorage.getItem('CourseLangIndex')
        const _data = {
            lang_id : this.getLanguageIcons[this.lang_index].id
        }
        this.systemPermissions = this.$store.getters.getSystemPermissions
        axios.post('/get-lesson-list/' + this.$route.params.id, _data, this.$store.getters.getAxiosConfig)
            .then(res => {
                this.content = res.data
                const bc = [
                    { text: res.data.brc.category.name, href: '/areas/' + res.data.brc.category.id },//#
                    { text: res.data.brc.area.name, href: '/courses/' + res.data.brc.area.id }, //#             
                    { text: res.data.brc.course.name + ' (user)', href: '/course_content/' + res.data.brc.course.id }, //#
                    { text: res.data.brc.course.name + ' (edit)', href: '/edit_chapters/' + res.data.brc.course.id }, //#
                    { text: res.data.brc.chapter.name, href: '/edit_lessons/' + res.data.brc.chapter.id }, //#
                ]
                this.$store.commit('setBreadCrumbs',bc)   
                                
                if (res.data.message != 'OK') {
                  this.access_denied = true
                  this.prepared = true
                  return
                }               
                this.prepared = true               
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
    },
    langClick(_index)  {
      localStorage.setItem('CourseLangIndex', _index)
      this.lang_index = _index       
    },
    addNewElement() {
      const _data = {
        lesson_id: 0,
        chapter_id: this.$route.params.id, 
        lesson_name: '',
        lesson_order: 0,  
        visibility: 1,       
        lang_id: parseInt(this.lang_index)+1,
        only_translation: 0
      }

      axios.post('/edit-lesson', _data, this.$store.getters.getAxiosConfig)
          .then(res => {
            if (res.data.message != 'OK') {
              this.$store.commit('setFeedback', res.data.message)
              return
            }            
            const _data1 = {
              id: res.data.id,
              order: res.data.order,
              translations: [],
              edit: 1 // to start edit in element
            }
            _data1.translations.push({lang_id: parseInt( this.lang_index)+1, name: '', visible: 1})
            this.content.element_list.push(_data1)              
          })
          .catch(error => {
              this.$store.commit('setFeedback', error)
          })
    },
    getObjectPermissions() {
      if (this.content.permissions.list[0].role_code >= this.$store.getters.getSystemPermissions.course_content_creator) return true      
      if (this.content.permissions.list[0].role_code == this.$store.getters.getSystemPermissions.chapter_content_creator) return true
      return false
    },
    changeOrder(_index) {
      const _data = {
        id1: this.content.element_list[_index].id,
        id2: this.content.element_list[_index+1].id,
        order1: this.content.element_list[_index].order,
        order2: this.content.element_list[_index+1].order,
        chapter_id: this.$route.params.id
      }

      axios.post('/change-lesson-order', _data, this.$store.getters.getAxiosConfig)
        .then(res => {
          if (res.data.message != 'OK') {
            this.$store.commit('setFeedback', res.data.message)
            return
          }     
          const _o1 = this.content.element_list[_index].order
          const _o2 = this.content.element_list[_index + 1].order
          const _data1 = this.content.element_list[_index]
          this.content.element_list.splice(_index,1)
          this.content.element_list.splice(_index+1, 0, _data1)         
          this.content.element_list[_index].order = _o1
          this.content.element_list[_index+1].order = _o2
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)
        })
    },

    tryDeleteElement(_index) {
      this.deleteIndex = _index
      this.$store.commit('setShowModalMessage',
                  {content: 'Are you sure?<br/>You want to delete lesson?', type: 'warning', 
                  buttons:[], icons:[{text:'close', color:'red', value: 1},{text:'done', color:'green', value: 2} ]})
    },
    processModalResult() {
      const res = this.getShowModalMessageResult
      this.$store.commit('setShowModalMessageResult',null)
      if (res == 2) this.deleteElement()        
    },
    deleteElement() {
      const _data = {
        id: this.content.element_list[this.deleteIndex].id,
        chapter_id: this.$route.params.id
      }
      axios.post('/delete-lesson', _data, this.$store.getters.getAxiosConfig)
        .then(res => {
          if (res.data.message != 'OK') {
            this.$store.commit('setFeedback', res.data.message)
            return
          }     
          this.content.element_list.splice(this.deleteIndex,1)
          this.deleteIndex = -1
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)
        })
    }
   }
  }
</script>

<style>

</style>